import IUserRepository from "../4_Repositories/IUserRepository";

export default class ValidAuthenticationUseCase {
  private _userRepository: IUserRepository;

  constructor(UserRepository: IUserRepository) {
    this._userRepository = UserRepository;
  }

  public async execute() {
    return await this._userRepository.validAuthentication();
  }
}
